import { analyticsConstants } from './../../constants/analytics.constants';
import {GlobalAnalyticsVariablesInterface} from '../interfaces';
import {retrieveMergeResponseGlobalVarsCase} from './retrieve-merge-response-global-vars.case';

export const trackPageErrorPayloadCase = (
  payload: any,
  globalVariables?: GlobalAnalyticsVariablesInterface,
) => {
  const data = {
    backendError: payload.backendError,
    channel: payload.channel,
    currentPage: payload.currentPage,
    errorCode: payload.errorCode,
    errorIdentifier: payload.errorIdentifier,
    errorMsg: payload.errorMsg,
    eventType: analyticsConstants.INTERACTION_EVENT_TYPE,
    interaction: payload.interaction,
    referringLinkLocation: payload.referringLinkLocation,
  };
  return retrieveMergeResponseGlobalVarsCase(true, data, globalVariables);
};
